<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="客户公司名称" value="company"></el-option>
              <el-option label="品牌" value="brand"></el-option>
              <el-option label="联系人姓名" value="name"></el-option>
              <el-option label="联系人电话" value="phone"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="创建时间" prop="time">
          <el-col :span="12">
            <el-date-picker v-model="form.time" type="datetimerange" range-separator="--" start-placeholder="开始日期"
              end-placeholder="结束日期" style="margin-right: 10px;" @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div>
          <el-button icon="el-icon-plus" @click="link('/client/add')" v-if="NodeInclude('195')">新增</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="id" label="客户编号" header-align="center" align="center" min-width="50" />
        <el-table-column prop="company" label="客户公司名称" header-align="center" align="center" min-width="200" />
        <el-table-column prop="brandStr" label="品牌" header-align="center" align="center" min-width="600" />
        <el-table-column prop="realname" label="创建者" header-align="center" align="center" min-width="80">
          <template slot-scope="scope">
            {{ scope.row.bkUserArr ? scope.row.bkUserArr.realname : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" width="100" align="center" fixed="right" v-if="NodeInclude('195') || NodeInclude('196')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="handleClick(scope.row)" v-if="NodeInclude('195')">编辑</el-link>
              <el-link type='primary' class="link" @click="viewClick(scope.row)" v-if="NodeInclude('196')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import store from '@/store'
export default {
  name: 'custom',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'company',
        time: ['', ''],
      },
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.clientType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '创建时间',
          val: 'time',
          value: this.dateValue(this.form.time),
          active: !!this.form.time && this.form.time[0] && !!this.form.time && this.form.time[1],
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  mounted() {
    this.getStoreFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },
    link(url) {
      this.$router.push(url)
    },
    handleClick(item) {
      console.log(item)
      this.$router.push({
        path: '/client/add',
        query: { id: item.id },
      })
    },
    viewClick(item) {
      console.log(item)
      this.$router.push({
        path: '/client/view',
        query: { id: item.id },
      })
    },
    search() {
      this.p = 1
      store.commit('setClientData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    getStoreFn() {
      this.form = Object.keys(store.state.clientData).length != 0 ? store.state.clientData : this.form
      this.getList()
    },
    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const time = this.form.time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        start_time: this.fdate(time[0]),
        end_time: this.fdate(time[1]),
        [this.form.atype]: this.form.key,//搜索
      }
      api.getClientList(postData).then((res) => {
        this.itemList = res.itemList
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level       
        }, 200);
      })
    },
    removeTag(tag) {
      if (tag.val === 'time') {
        this.form.time = ['', '']
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setClientData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setClientData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;
  .filter {
    width: 85%;
  }
  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.linkwrap {
  font-size: 12px;
  &.normal {
    color: #606266;
    a {
      color: #606266;
      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }
      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
